import cn from 'classnames';
import type { FunctionComponent } from 'react';
import style from './Logo.module.scss';

const LETTERS =
  'M61.5 86L61.5 100L6 100L6 30L61.5 30L61.5 44L24 44L24 57.5L53.5 57.5L53.5 71.5L24 71.5L24 86L61.5 86M86.5 87.5L82 100L62.5 100L89 30L109 30L135.5 100L116 100L111.5 87.5L86.5 87.5M99 51L91 74.5L107 74.5L99 51M140.5 100L140.5 30L182.5 30Q193 30 197.8 34.8Q202.5 39.5 202.5 50L202.5 59Q202.5 67.3 199.8 71.9Q197 76.5 191 78L203.5 100L184 100L172.5 79L158.5 79L158.5 100L140.5 100M184.5 59L184.5 50Q184.5 44 178.5 44L158.5 44L158.5 65L178.5 65Q184.5 65 184.5 59M247.5 30L263.5 30L275.5 75L286 30L305.5 30L286.5 100L267.5 100L255.5 56.5L243.5 100L224.5 100L205.5 30L225 30L235.5 75M393.5 100L393.5 30L435.5 30Q446 30 450.8 34.8Q455.5 39.5 455.5 50L455.5 59Q455.5 67.3 452.8 71.9Q450 76.5 444 78L456.5 100L437 100L425.5 79L411.5 79L411.5 100L393.5 100M437.5 59L437.5 50Q437.5 44 431.5 44L411.5 44L411.5 65L431.5 65Q437.5 65 437.5 59M525.5 100L525.5 61L511.5 86L497.5 86L483.5 61L483.5 100L465.5 100L465.5 30L484.5 30L504.5 67L524.5 30L543.5 30L543.5 100';

interface Props {
  className?: string;
  full?: boolean;
}

const Loop: FunctionComponent = () => (
  <>
    <path d="M42 14.7A20 20 0 1 0 52 32" fill="none" strokeWidth="10" />
    <polygon points="42,33 62,33 52,19" />
  </>
);

export const Logo: FunctionComponent<Props> = ({ className, full = false }) => (
  <span role="img" aria-label="Earworm" className={cn(style.logo, className)}>
    <svg viewBox="6 29 538 72" aria-hidden="true" className={cn(style.wordmark, { [style.wide]: !full })}>
      <path d={LETTERS} className={style.letters} />
      <g transform="translate(298.2 20.2) scale(1.4)" className={style.loop}>
        <Loop />
      </g>
    </svg>
    {full ? null : (
      <svg viewBox="7 7 55 50" aria-hidden="true" className={style.mark}>
        <g className={style.loop}>
          <Loop />
        </g>
      </svg>
    )}
  </span>
);
